.modal {
  max-height: 100svh;
}

.content {
  padding: var(--mirai-ui-space-M);
  gap: var(--mirai-ui-space-XS);
  border-bottom: 1px solid var(--mirai-ui-content-border);
}

.buttons,
.buttons > ui-view {
  gap: var(--mirai-ui-space-M);
  justify-content: space-between;
}

.buttons.settings {
  justify-content: flex-end;
}

.buttons ui-button {
  width: calc(var(--mirai-ui-space-XL) * 2);
}

.settings {
  margin-top: var(--mirai-ui-space-XXS);
}

.settings > ui-view {
  border: 1px solid var(--mirai-ui-content-border);
  border-radius: var(--mirai-ui-border-radius);
}

.settings .info {
  margin: var(--mirai-ui-space-S);
  margin-top: 0;
}

.settings .info > *,
.action {
  display: inline;
}

.setting {
  justify-content: space-between;
  padding: var(--mirai-ui-space-S);
  min-height: var(--mirai-ui-space-XL);
}

.setting.last {
  border-top: 1px solid var(--mirai-ui-content-border);
}

.setting > * {
  display: flex;
  margin-bottom: 0;
  width: auto;
}

/* S */
@media only screen and (max-width: 480px) {
  .content {
    width: auto;
    padding: var(--mirai-ui-space-S);
    overflow-y: auto;
  }

  .settings {
    gap: var(--mirai-ui-space-S);
  }

  .buttons {
    padding: var(--mirai-ui-space-S);
  }

  .buttons:not(.settings) {
    align-items: center;
  }

  .buttons ui-button {
    width: auto;
  }
}

/* M & L */
@media only screen and (min-width: 481px) {
  .content {
    width: calc(var(--mirai-ui-space-XXL) * 10);
  }

  .settings {
    gap: var(--mirai-ui-space-M);
  }

  .buttons {
    padding: var(--mirai-ui-space-M);
  }
}
